import { jwtDecode } from "jwt-decode";

export const isTokenExpired = (token?: string): boolean => {
  if (!token) return true;

  try {
    const decoded: { exp?: number } = jwtDecode(token);
    return !decoded.exp || decoded.exp * 1000 < Date.now();
  } catch {
    return true;
  }
};
